// TODO
// eslint-disable-next-line @typescript-eslint/naming-convention
export interface AuthProtocol {
  getToken(): any;
}
